// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i5BlssX55aBGOb {
  width: 48px;
  height: 48px;
  padding: var(--ds-space-200, 16px);
  border-radius: var(--ds-radius-xxlarge, 16px);
  background: var(--ds-background-brand-boldest, #1c2b41);
  box-shadow: var(--ds-shadow-raised, 0 1px 1px #091e4240);
  cursor: pointer;
  border: none;
  justify-content: center;
  align-items: center;
  transition: all .2s;
  display: flex;
  position: relative;
}

.i5BlssX55aBGOb.S0cefKZwRQo9b0:hover {
  background: var(--ds-background-brand-boldest-hovered, #09326c);
  box-shadow: var(--ds-shadow-overlay, 0 8px 16px #00000029);
  transform: scale(1.125);
}

.i5BlssX55aBGOb:hover {
  background: var(--ds-background-brand-boldest-hovered, #09326c);
  transform: scale(1.125);
}

.i5BlssX55aBGOb.J3l9JoxyBDFX5k {
  border: var(--ds-border-width, 1px) solid var(--ds-border-selected, #0c66e4);
}
`, ""]);
// Exports
export var rovoButton = `i5BlssX55aBGOb`;
export var cardBackButton = `S0cefKZwRQo9b0`;
export var chatOpen = `J3l9JoxyBDFX5k`;
export default ___CSS_LOADER_EXPORT___;
